import { render, staticRenderFns } from "./ProductEditAccounting.vue?vue&type=template&id=665c3d13"
import script from "./ProductEditAccounting.vue?vue&type=script&lang=ts"
export * from "./ProductEditAccounting.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('665c3d13')) {
      api.createRecord('665c3d13', component.options)
    } else {
      api.reload('665c3d13', component.options)
    }
    module.hot.accept("./ProductEditAccounting.vue?vue&type=template&id=665c3d13", function () {
      api.rerender('665c3d13', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/ProductEditAccounting.vue"
export default component.exports